export default __webpack_public_path__ + "static/media/ButtonApply.cdc835ee.png";